export default __webpack_public_path__ + "static/media/RestaurantLandingPage.94d9e950.jpeg";